import {
  Package,
  RotateCcw,
  Building,
  ShieldCheck,
  Wallet,
  Tag,
} from "lucide-react";

import { MapPin } from "lucide-react";
import { FaBoxesStacked } from "react-icons/fa6";

export default function Features() {
  const services = [
    {
      title: "Parcel Delivery",
      desc: "Send small & medium parcels across the city",
      icon: <Package size={20} className="text-orange-500" />,
    },
    {
      title: "Bulk Delivery",
      desc: "Efficient logistics for multiple packages",
      icon: <FaBoxesStacked size={20} />,
    },
    {
      title: "Return Services",
      desc: "Easy pick-up and return of items",
      icon: <RotateCcw size={20} />,
    },
    {
      title: "Business(B2B)",
      desc: "Reliable delivery solutions for business & shops",
      icon: <Building size={20} />,
    },
  ];

  const whyChoose = [
    {
      title: "Real-time Tracking",
      desc: "Track your delivery at every step",
      icon: <MapPin size={20} className="text-orange-500" />,
      color: "orange",
    },
    {
      title: "Secure Wallet System",
      desc: "Safe, fast and easy in-app payments",
      icon: <Wallet size={20} />,
      color: "green",
    },
    {
      title: "Affordable Pricing",
      desc: "Competitive rates with no hidden fees",
      icon: <Tag size={20} className="rotate-90 text-orange-500" />,
      color: "orange",
    },
    {
      title: "Reliable Network",
      desc: "Trusted riders ensuring safe delivery",
      icon: <ShieldCheck size={20} />,
      color: "green",
    },
  ];

  return (
    <div className="py-16 px-10 bg-gray-100">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
        {/* COLUMN 1 → OUR SERVICES */}
        <div>
          <h2 className="text-xl font-bold mb-6">
            <span className="text-black">Our</span>{" "}
            <span className="text-orange-500">Services</span>
          </h2>

          <div className="grid grid-cols-2 gap-4">
            {services.map((item, i) => (
              <div
                key={i}
                className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition"
              >
                <div className="flex items-center gap-3">
                  {/* ICON */}
                  <div
                    className={`flex items-center justify-center flex-shrink-0 ${
                      i === 0 ? "text-orange-600" : "text-green-600"
                    }`}
                  >
                    {item.icon}
                  </div>

                  {/* TEXT */}
                  <div className="flex flex-col justify-center">
                    <h3 className="font-semibold text-sm text-gray-800 leading-tight">
                      {item.title}
                    </h3>

                    <p className="text-gray-500 text-xs mt-1 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* COLUMN 2 → WHY CHOOSE JOPO */}
        <div>
          <h2 className="text-xl font-bold mb-6">
            <span className="text-black">Why Choose</span>{" "}
            <span className="text-orange-500">Jopo?</span>
          </h2>

          <div className="space-y-5">
            {whyChoose.map((item, i) => (
              <div key={i} className="flex items-center gap-4">
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-md flex-shrink-0 ${
                    item.color === "orange"
                      ? "bg-orange-100 text-orange-500"
                      : "bg-green-100 text-green-600"
                  }`}
                >
                  {item.icon}
                </div>

                <div>
                  <p className="text-gray-800 font-medium">{item.title}</p>

                  <p className="text-gray-500 text-sm mt-1">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* COLUMN 3 → CTA */}
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-lg font-bold text-gray-800 mb-3">
            Fast & Reliable Delivery
          </h3>

          <p className="text-gray-500 text-sm mb-6">
            Jopo connects you with trusted riders to ensure your packages are
            delivered quickly, safely, and at affordable rates.
          </p>

          <ul className="space-y-3 text-sm text-gray-600 mb-6">
            <li>✔ Same-day delivery services</li>
            <li>✔ Real-time tracking</li>
            <li>✔ Secure and reliable riders</li>
            <li>✔ Affordable pricing</li>
          </ul>

          <button className="bg-orange-500 text-white px-5 py-2 rounded-lg hover:bg-orange-600 transition">
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}
